/**
 * Validates if a file is a supported image (PNG, JPEG, WEBP, or iPhone HEIC).
 * HEIC/HEIF files are allowed because uploadFile() converts them to JPEG
 * server-side via /api/convert-heic.
 * @param {File} file - The file to validate
 * @returns {Object} - { isValid: boolean, errorMessage?: string }
 */
export const validateImageFile = (file) => {
  if (!file) {
    return { isValid: false, errorMessage: 'No file selected' };
  }

  const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp', 'image/heic', 'image/heif'];
  const validExtensions = ['.png', '.jpg', '.jpeg', '.webp', '.heic', '.heif'];

  // Check MIME type (often empty/wrong for HEIC, so extension is the fallback)
  const isValidType = validTypes.includes((file.type || '').toLowerCase());

  const fileName = file.name.toLowerCase();
  const hasValidExtension = validExtensions.some(ext => fileName.endsWith(ext));

  if (!isValidType && !hasValidExtension) {
    return {
      isValid: false,
      errorMessage: 'Only JPEG, PNG, WEBP, and iPhone (HEIC) photos are supported. Please select a different image.'
    };
  }

  return { isValid: true };
};

